import { ui } from "@/components/ui";
import ConsentCall from "@/features/consent/ConsentCall";
import { useDiaryByIdQuery } from "@/features/diaries/api/diaryQueries";
import HistoryByTracker from "@/features/diaries/features/history/components/HistoryByTracker";
import DueObservationCall from "@/features/diaries/features/new/components/DueObservationCall";
import DiarySkeleton from "@/features/patients/components/DiarySkeleton";
import { interfaceComponents as ic } from "@/features/patients/features/interface/components";
import DiaryTitle from "@/features/patients/features/interface/components/DiaryTitle";
import InterfaceButtons from "@/features/patients/features/interface/components/InterfaceButtons";
import { hooks as h } from "@/hooks";
import { createFileRoute } from "@tanstack/react-router";
import MissingDiaryDetailsCall from "../../../../features/diaries/components/MissingDiaryDetailsCall";
import StateCard from "../../../../features/patients/features/interface/components/StateCard";

const PatientsDiaryIdPage = () => {
	const { diaryId } = Route.useParams();
	const { data: diary, isPending } = useDiaryByIdQuery(diaryId);

	h.useNav(
		diaryId
			? [
					{ label: "Patients", route: { to: "/patients" } },
					{
						label: diary?.diary_name ?? "Diary",
						route: {
							to: "/patients/$diaryId",
							params: { diaryId: diaryId },
						},
					},
				]
			: [{ label: "Patients", route: { to: "/patients" } }],
	);

	if (isPending || !diary) {
		return <DiarySkeleton />;
	}

	return (
		<section className="flex flex-col h-full">
			<InterfaceButtons diaryId={diaryId} />
			<ui.ScrollArea>
				<div className="flex flex-col gap-y-4 mt-3 h-full">
					<DiaryTitle
						patientName={diary.patient_info?.patient_name as string}
						isEditing={false}
						diaryId={diaryId}
					/>

					<StateCard diary={diary} />
					{/* <ic.AiSummary diary={diary} /> */}
					{/* {diary.trackers_view?.length > 0 && <AllCharts diary={diary} />} */}
					<MissingDiaryDetailsCall diary={diary} />
					<ConsentCall diaryId={diaryId} />
					{diary.observations_view.map((ov) => (
						<DueObservationCall key={ov.observation_id} observation={ov} />
					))}
					<HistoryByTracker diary={diary} />
					<br className="pt-16" />
				</div>

				<ui.ScrollBar className="translate-x-6" />
			</ui.ScrollArea>
		</section>
	);
};

export const Route = createFileRoute("/_app/patients/$diaryId/")({
	component: PatientsDiaryIdPage,
});
